
import React, { useState } from 'react';
import TeamSectionHeader from './team/TeamSectionHeader';
import TeamMemberCard from './team/TeamMemberCard';
import WhyOurTeamSection from './team/WhyOurTeamSection';
import { teamMembers } from './team/teamData';

const CombinedTeamSection: React.FC = () => {
  const [flippedCard, setFlippedCard] = useState<number | null>(null);

  console.log('CombinedTeamSection rendering with team members:', teamMembers.length);
  console.log('Flipped card state:', flippedCard);

  const toggleFlipped = (index: number) => {
    console.log('Toggle flip called for index:', index, 'current flipped:', flippedCard);
    setFlippedCard(flippedCard === index ? null : index);
  };
  
  return (
    <section className="py-16 bg-gradient-to-br from-blue-50/80 via-indigo-50/60 to-purple-50/70 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-200/30 to-indigo-200/40 rounded-full blur-3xl -translate-x-48 -translate-y-48" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-br from-purple-200/30 to-pink-200/40 rounded-full blur-3xl translate-x-48 translate-y-48" />
      <div className="absolute top-1/2 left-1/3 w-72 h-72 bg-gradient-to-br from-cyan-200/20 to-blue-200/30 rounded-full blur-2xl" />
      
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
      
      <div className="container mx-auto relative z-10" itemScope itemType="https://schema.org/Organization">
        <meta itemProp="name" content="My Pet ID" />
        <meta itemProp="description" content="Secure pet document management and reminder platform" />
        
        <TeamSectionHeader />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {teamMembers.map((member, index) => {
            console.log('Rendering team member:', member.name, 'at index:', index);
            return (
              <TeamMemberCard
                key={`team-member-${index}-${member.name}`}
                member={member}
                index={index}
                isFlipped={flippedCard === index}
                onToggleFlipped={toggleFlipped}
              />
            );
          })}
        </div>
        
        <WhyOurTeamSection />
      </div>
    </section>
  );
};

export default CombinedTeamSection;
